import { render, staticRenderFns } from "./FreeReceipt.vue?vue&type=template&id=15f29798&scoped=true"
import script from "./FreeReceipt.vue?vue&type=script&lang=js"
export * from "./FreeReceipt.vue?vue&type=script&lang=js"
import style0 from "./FreeReceipt.vue?vue&type=style&index=0&id=15f29798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f29798",
  null
  
)

export default component.exports